export default {
    showNavigation: false
}